import {BrowserCacheLocation, Configuration, LogLevel} from '@azure/msal-browser';
import {environment} from '../../../../environments/environment';
import {loggerCallback} from '../../../app.module';

// Sign In For Both Types
export const msalCustomersSignIn: Configuration = {
  auth: {
    clientId: environment.msalConfig.customers_auth.clientId,
    authority: environment.b2cCustomerPolicies.authorities.signInPolicyId.authority,
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: `${window.location.origin}/`,
    knownAuthorities: [environment.b2cCustomerPolicies.authorityDomain]
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback,
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
}

// // Sign Up For Businesses
//
// export const msalCustomersBusinessSignUp: Configuration = {
//   auth: {
//     clientId: environment.msalConfig.customers_auth.clientId,
//     authority: environment.b2cCustomerPolicies.authorities.businessSignUpPolicyId.authority,
//     redirectUri: '/',
//     postLogoutRedirectUri: '/',
//     knownAuthorities: [environment.b2cCustomerPolicies.authorityDomain]
//   },
//   cache: {
//     cacheLocation: BrowserCacheLocation.LocalStorage
//   },
//   system: {
//     allowNativeBroker: false, // Disables WAM Broker
//     loggerOptions: {
//       loggerCallback,
//       logLevel: LogLevel.Verbose,
//       piiLoggingEnabled: false
//     }
//   }
// }
//
// // Sign Up For Individuals
//
// export const msalCustomersIndividualSignUp: Configuration = {
//   auth: {
//     clientId: environment.msalConfig.customers_auth.clientId,
//     authority: environment.b2cCustomerPolicies.authorities.individualSignUpPolicyId.authority,
//     redirectUri: '/',
//     postLogoutRedirectUri: '/',
//     knownAuthorities: [environment.b2cCustomerPolicies.authorityDomain]
//   },
//   cache: {
//     cacheLocation: BrowserCacheLocation.LocalStorage
//   },
//   system: {
//     allowNativeBroker: false, // Disables WAM Broker
//     loggerOptions: {
//       loggerCallback,
//       logLevel: LogLevel.Verbose,
//       piiLoggingEnabled: false
//     }
//   }
// }
